<template lang="pug">
  div#popup
    span(@click='close')
      ods-icon.iconClose(name="close" size="20")
    div.containerDataPopup
      div.containerTitleDataPopup
        p {{ stationName }}
        span {{ valorComparado }}
      div.containerValuesPopup(v-loading="dataCompareLoad")
        template(v-if='!dataCompare && !dataCompareLoad')
          StatusCero(
            title='no data'
            description='no data kpi compare'
          )
        ods-scrollbar(v-else wrap-class='ods-scrollbar__wrap')
          div.maxSizePopup
            div(v-for='(rowKpi, index) in datosFinal')
              span.tipo {{ $t(rowKpi.tipo) }}:
              span.valor {{ rowKpi.valor }} {{ $t(rowKpi.unit) }}
</template>

<script>
import StatusCero from '@/components/StatusCero'
export default {
  name: 'PopupCompare',
  props: {
    datosFinal: {
      type: Array
    },
    dataCompare: {
      type: Boolean
    },
    dataCompareLoad: {
      type: Boolean
    },
    stationName: {
      type: String
    },
    valorComparado: {
      type: String
    }
  },
  methods: {
    close () {
      var eventSetCompare = new CustomEvent('setPopupCompare', { detail: false })
      document.dispatchEvent(eventSetCompare)
      window.parent.document.getElementById('dataIframe').contentWindow.resetEntityCards()
    }
  },
  components: {
    StatusCero
  }
}
</script>

<style scoped lang="scss">

#popup {
  background: $--color-white;
  border-radius: 5px;
  bottom: rem(16);
  // display: none;
  // left: calc(24px + 72px);
  left: rem(16);
  // padding-right: rem(24);
  padding: rem(16) rem(32);
  padding-top: rem(32);
  position: absolute;
  transition: width 0.4s, min-width 0.4s, opacity 0.4s;
  width: auto;
  z-index: 10;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
  .iconClose {
    cursor: pointer;
    position: absolute;
    top: rem(8);
    right: rem(8);
  }
}
.containerDataPopup {
  .containerTitleDataPopup {
    padding-bottom: rem(16);
    margin-bottom: rem(16);
    border-bottom: 1px solid $--color-neutral-3;
    margin-right: rem(8);
    p {
      font-size: rem(16);
      margin-bottom: 4px;
    }
    span {
      text-transform: uppercase;
      background: $--color-primary-light-9;
      padding: 4px;
      display: inline-block;
      border-radius: 5px;
      font-size: 9px;
    }
  }
  .containerValuesPopup{
    min-height: rem(50);
  }
}
.maxSizePopup {
  max-height: rem(120);
  padding-right: rem(24);
  text-transform: uppercase;
  div {
    margin-bottom: rem(16);
    font-size: rem(10);
    .tipo {
      font-weight: bold;
      margin-right: rem(8);
    }
    .valor {
      color: $--color--grey-medium;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/PopupCompare.vue